import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {MonthlyReportForClinic} from "../monthly-report-for-clinic.model";

export class MonthlyReportForClinicDgSearchResults extends GenericDgSearchResults {
  public results: MonthlyReportForClinic[];

  constructor(total: number, results: MonthlyReportForClinic[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

